import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
} from 'react-router-dom';

import './css/App.css';
import logo from './img/logo.gif';

import Home from './controller/Home';
import Projetos from './controller/Projetos';


const MenuLink = ({ label, to, activeOnlyWhenExact }) => (
  <Route
    path={to}
    exact={activeOnlyWhenExact}
    children={ ({ match }) => (
      <li><Link className={match ? "active" : ""} to={to}>{label}</Link></li>
    )}
  />
);

class App extends Component {

  constructor(props) {
    super(props);
    // Setting up initial state
    this.state = {
      listaItens: []
    }
  }

  // calling the componentDidMount() method after a component is rendered for the first time
  componentDidMount() {
    //
  }

  // calling the componentWillUnMount() method immediately before a component is unmounted from the DOM
  componentWillUnmount() {
    //this.serverRequest.abort();
  }

  render() {
//    var titles = []

    return (
      <Router>
        <div className="container">

          {/* HEADER */}
          <div className="header-content col-md-6 col-md-offset-3 col-xs-12">
            <div className="content">
              <div className="logo-header text-center">
                <a href="/">
                  <img src={logo} alt="Pixirt" />
                </a>
              </div>
              <nav className="main-menu navbar navbar-default">
                <div className="container-fluid">
                  <div className="" id="main-navbar">
                    <ul className="nav navbar-nav pull-left">
                      <MenuLink label="Home" to="/" activeOnlyWhenExact={true} />
                      <MenuLink label="Projetos" to="/projetos" />
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
          {/* HEADER */}

          {/* CONTENT */}
          <div className="main-content col-md-6 col-md-offset-3 col-xs-12">
            <Route exact path="/" component={Home} />
            <Route path="/projetos" component={Projetos} />
          </div>
          {/* CONTENT */}

          {/* FOOTER */}
          <div className="footer-content col-md-6 col-md-offset-3 col-xs-12">
            <div className="content">
              <div className="pull-left"><a target="_blank" rel="noopener noreferrer" href="http://raulmalavasi.com.br">Raul Malavasi</a></div>
              <div className="pull-right">Powered by (D8 + React)</div>
              <div className="clearfix"></div>
            </div>
          </div>
          {/* FOOTER */}

        </div>
      </Router>
    );
    //"2018-04-22T18:42:20+00:00",[0].value

  }

}

export default App;

// rendering into the DOM
//ReactDOM.render(
//    <App source="http://adm.pixirt.com/api/artigos?_format=json" />,
//    document.getElementById('container')
//);



// WEBPACK FOOTER //
// ./src/App.js